// extracted by mini-css-extract-plugin
module.exports = {"participant":"Participant_participant__3KUqY"};